<template>
  <div :id="id" class="chart-height-full">
  </div>
</template>

<script>
import * as echarts from 'echarts'
import resize from '@/components/echarts/mixins/resize'
export default {
  mixins: [resize],
  name: 'ProportionAgentContribution',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    seriesType: {
      default: () => {
        return {
          radius: ['45%', '65%'],
          center: ['35%', '50%']
        }
      }
    },
    id: {
      type: String,
      default: 'ProportionAgentContribution'
    }
  },
  data () {
    return {
      chart: null,
      testOptions: {
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: '60%',
          y: 'center',
          data: ['年度目标', '邮件营销'],
          icon: 'circle',
          formatter: function (name) {
            var arr = [
              `{b|${name}}`
            ]
            return arr.join('\n')
          },
          textStyle: {
            rich: {
              b: {
                fontSize: 12,
                color: 'white'
              }
            }
          },
          selectedMode: false
        },
        series: [
          {
            name: '代理商贡献占比',
            type: 'pie',
            radius: ['45%', '65%'],
            data: [],
            hoverAnimation: false,
            label: {
              position: 'inside',
              formatter: '{d}%'
            },
            labelLine: {
              show: false
            },
            center: ['35%', '50%']
          }
        ]
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.testOptions.series[0].radius = this.seriesType.radius
    this.testOptions.series[0].center = this.seriesType.center
    this.initChart()
  },
  watch: {
    data: {
      immediate: true,
      handler: function (newValue) {
        if (!newValue) { return }
        let listData = Object.entries(newValue)
        if (listData.length > 0) { this.initOptions(listData) }
      }
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      this.chart.setOption(this.testOptions)
    },
    initOptions (val) {
      let legendData = []
      let seriesData = []
      let colorLists = ['#1d5eeb', '#65d5d1', '#edcd4b', '#e26032', '#312d6f', '#866dbc']
      // this.testOptions.legend.data = val.map(item => item[0])
      val.forEach((item, index) => {
        legendData.push(item[0])
        seriesData.push({
          value: item[1],
          name: item[0],
          itemStyle: {
            color: colorLists[index]
          }
        })
      })
      this.testOptions.legend.data = legendData
      this.testOptions.series[0].data = seriesData
      this.refreshOptions(this.testOptions)
    },
    refreshOptions (val) {
      if (this.chart) {
        this.chart.setOption(val)
      }
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.chart-height-full
  height 100%
  width 100%
</style>
